import { Tooltip } from "react-tooltip";
import { utils, writeFileXLSX } from "xlsx";
const ExcelButton = ({ headers, data, name, properties }) => {
  const exportarXLSX = () => {
    let data_export = [];

    if (data[0].datos) {
      data.forEach((element) => {
        element.datos.forEach((dato) => {
          let array = [];
          properties.forEach((prop) => {
            array.push(dato[prop]);
          });
          data_export.push(array);
        });
      });
    } else {
      data.forEach((element) => {
        let array = [];
        properties.forEach((prop) => {
          array.push(element[prop]);
        });
        data_export.push(array);
      });
    }
    const wb = utils.book_new();
    const ws = utils.aoa_to_sheet(headers.concat(data_export));
    utils.book_append_sheet(wb, ws, "Repostajes");
    writeFileXLSX(wb, `${name}.xlsx`);
  };

  return (
    <>
      <button
        data-tooltip-id="excel-tooltip"
        data-tooltip-content="Exportar en Excel"
        className="border-0 bg-success rounded mr-1 ml-1"
        onClick={exportarXLSX}
      >
        <span className="mdi mdi-file-excel text-white"></span>
      </button>
      <Tooltip id="excel-tooltip" />
    </>
  );
};

export default ExcelButton;
